import { FunctionComponent } from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { GridBaseIconProps } from '@mui/x-data-grid-pro';

export const DetailPanelCollapseIcon: FunctionComponent<GridBaseIconProps> = ({ fontSize }) => (
  <ChevronRightIcon
    fontSize={fontSize}
    style={{ transform: 'rotate(90deg)' }}
  />
);
